import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */import { debug as _debug, info as _info, warn as _warn, error as _error, fatal as _fatal } from './actions';
/**
 * Logger to call log actions
 *
 * ## Usage
 *
 * ``` javascript
 * import { logging } from 'gandi-application-logger';
 *
 * const logger = logging(dispatch, 'myNamespace');
 * logger.info('*** I am an awesome log ***')
 * ```
 */
export var logging = function logging(dispatch, namespace) {
  var log = function log(action, fields, msg) {
    /*
    Either field is object and msg string,
     or fields is string and msg is empty
     */
    if (typeof fields === 'string') {
      dispatch(action({
        namespace: namespace
      }, fields));
    } else {
      dispatch(action(_objectSpread(_objectSpread({}, fields), {}, {
        namespace: namespace
      }), msg || ''));
    }
  };
  return {
    debug: function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return log.apply(void 0, [_debug].concat(args));
    },
    info: function info() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return log.apply(void 0, [_info].concat(args));
    },
    warn: function warn() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return log.apply(void 0, [_warn].concat(args));
    },
    error: function error() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return log.apply(void 0, [_error].concat(args));
    },
    fatal: function fatal() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return log.apply(void 0, [_fatal].concat(args));
    }
  };
};